import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { decryptData } from '../../../helpers/encrypt/crypto-encrypt'

export const MaxLimitAction = createAsyncThunk('maxUserLimit', async (_, { rejectWithValue }) => {
    try {
        const limitExceed = decryptData(sessionStorage?.limit_exceeds)
        const isUserLimitExceeded = limitExceed ? limitExceed : {}
        const data = {
            isUserLimitExceeded,
            message: 'Usage limit reached.',
        }

        return data
    } catch (error) {
        return rejectWithValue('Failed to retrieve user limit status')
    }
})

const MaxLimitSlice = createSlice({
    name: 'maxUserLimit',
    initialState: {
        isLoading: false,
        data: false,
        success: false,
        error: null,
    },
    reducers: {
        MaxLimitReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false,
            }
        },
    },
    extraReducers: {
        [MaxLimitAction.pending]: (state) => {
            state.isLoading = true
            state.error = null
            state.success = false
        },
        [MaxLimitAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false
            state.data = payload
            state.error = null
            state.success = true
        },
        [MaxLimitAction.rejected]: (state, { payload }) => {
            state.isLoading = false
            state.error = payload
            state.success = false
        },
    },
})

export const { MaxLimitReset } = MaxLimitSlice.actions
export default MaxLimitSlice.reducer
